import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect"
import { GoArrowDownRight } from "react-icons/go";
import { imagenesAll } from "../asset/img";
import { IsPcHeader } from "../componentes/Principales";
import { useForm, ValidationError } from "@formspree/react";
import { TiMessages } from "react-icons/ti";

export const Contacto =()=>{
  return(
    <>
      {isMobile ? <ContactoMobile /> : <ContactoDesktop />}
    </>
  )
}

export const ContactoDesktop = () => {
  const [formData, setFormData] = useState({
    aceptaTerminos: false,
  });
  const [error, setError] = useState("");

  const [state, handleSubmitFormspree] = useForm("mqaljogj");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.aceptaTerminos) {
      setError("Debes aceptar los términos y condiciones.");
      return;
    }

    setError("");
     window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
    handleSubmitFormspree(e); // envía el formulario a Formspree

  };

  useEffect(() => {
    document.title = "WAZ - Contacto";
  }, []);
  useEffect(() => {
    if (state.succeeded) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [state.succeeded]);

  if (state.succeeded) {
    return <div className="">
       <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
       <div className="ma_contacto_send m_bg_primary  w-100 m_h70vh d-flex justify-content-center align-items-center flex-column text-black ">
        <p className="fs-3 fw-bold ">¡Gracias por ponerte en<br/> contacto con nosotros!</p>
        <span><TiMessages color="#f56763" size={40}/></span>
        <p className="m_p_lm ">Nos alegra saber que estás interesado en nuestros servicios.</p>
        <p className="m_p_lm ">Uno de nuestros representantes se pondrá en contacto lo <br/>antes posible para conversar más detalles sobre tu consulta.</p>
       </div>
    </div>;
  }

  return (
    <div className="ma_vHeader_contacto pb-1">
      <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
      <div className="d-flex flex-column align-items-around justify-content-around mb-5 pb-5">
        <div className="ms-5 ps-5 mt-5 pt-5 d-flex flex-column">
          <div>
            <span className="m_bg_amarillo px-2 rounded-2"> HI YOU!</span>
          </div>
          <span className="m_text_secondary m_hl m_h2">
            Nos Conozcamos{" "}
            <span className="m_bg_primary m_text_secondary rounded-5 px-2 pb-2">
              <GoArrowDownRight />
            </span>
          </span>
          <p className="m_text_secondary fs-5">
            Estamos a un formulario de conocernos y
            <br />
            crear una experiencia única de Marketing.
          </p>
        </div>

        <div className="w-100 d-flex align-items-end justify-content-end">
          <div className="col-7">
            <div className="container">
              <div className="row">
                <div className="col-lg-10">
                  <form
                    onSubmit={handleSubmit}
                    className="p-4 border-0 m_tl fs-5 rounded m_form_contacto conteiner"
                  >
                    <div className="row my-4 d-flex justify-content-between px-1">
                      <input
                        placeholder="Nombre Completo*"
                        type="text"
                        name="nombre"
                        className="m_font_primary col-5 mx-1"
                        onChange={handleChange}
                        required
                      />
                      <input
                        placeholder="Empresa"
                        type="text"
                        name="empresa"
                        className="col-5 mx-1"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="row my-4 d-flex justify-content-between px-1">
                      <input
                        placeholder="Correo electrónico*"
                        type="email"
                        name="email"
                        className="col-5 mx-1"
                        onChange={handleChange}
                        required
                      />
                      <input
                        placeholder="Servicio de interés*"
                        type="text"
                        name="servicio"
                        className="col-5 mx-1"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="row my-4 d-flex justify-content-between px-1">
                      <input
                        placeholder="Número de teléfono"
                        type="tel"
                        name="telefono"
                        className="col-5 mx-1"
                        onChange={handleChange}
                      />
                      <input
                        placeholder="¿Cómo nos has encontrado?"
                        type="text"
                        name="fuente"
                        className="col-5 mx-1"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="my-4 m-0 w-100">
                      <textarea
                        name="proyecto"
                        className="form-control rounded-0 m_text_area m_bg_f2f2f2"
                        rows="4"
                        placeholder="Cuéntanos tu proyecto"
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        name="aceptaTerminos"
                        className="form-check-input m_contacto_formInput"
                        checked={formData.aceptaTerminos}
                        onChange={handleChange}
                      />
                      <label className="m_text_orange m_bl">
                        Acepto que WAZ utilice mis datos personales para responder a esta consulta.
                      </label>
                    </div>

                    {error && <p className="text-danger">{error}</p>}

                    <div className="text-end me-4">
                      <button type="submit" className="ma_button_name px-5" disabled={state.submitting}>
                        Enviar
                      </button>
                    </div>

                    {/* Validation Errors */}
                    <ValidationError prefix="Nombre" field="nombre" errors={state.errors} />
                    <ValidationError prefix="Email" field="email" errors={state.errors} />
                    <ValidationError prefix="Mensaje" field="proyecto" errors={state.errors} />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ContactoMobile = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    empresa: "",
    email: "",
    servicio: "",
    telefono: "",
    fuente: "",
    proyecto: "",
    aceptaTerminos: false,
  });

  const [error, setError] = useState("");
  const [state, handleSubmitFormspree] = useForm("mqaljogj"); // Igual que desktop

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.aceptaTerminos) {
      setError("Debes aceptar los términos y condiciones.");
      return;
    }
    setError("");

    window.scrollTo({ top: 0, behavior: "smooth" });
    handleSubmitFormspree(e);
  };

  useEffect(() => {
    if (state.succeeded) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [state.succeeded]);

  if (state.succeeded) {
    return (
      <div className="m_contacto_headerVector_mobile ma_nosotros_cortina_ceoMobile">
        <div className="w-100 m_h70vh d-flex m_dfc flex-column text-black text-center">
          <p className="fs-3 fw-bold ">
            ¡Gracias por ponerte en contacto con nosotros!
          </p>
          <span><TiMessages color="#f56763" size={40} /></span>
          <p className="m_p_lm">
            Nos alegra saber que estás interesado en nuestros servicios.
          </p>
          <p className="m_p_lm">
            Uno de nuestros representantes se pondrá en contacto lo antes posible para conversar más detalles sobre tu consulta.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="m_contacto_headerVector_mobile">
      {/* encabezado */}
      <div className="mt-5 pb-3 pt-5">
        <div className="ms-3">
          <span className="m_bg_amarillo px-2 rounded-2"> HI YOU!</span>
        </div>
        <span className="m_text_secondary m_hl fs-1 mx-3">Nos Conozcamos</span>
        <p className="m_text_secondary fs-3 mx-3">
          Estamos a un formulario de <br /> conocernos y crear una
          <br /> experiencia única de Marketing.
        </p>
        <span className="m_bg_primary m_text_secondary rounded-5 py-4 px-2 ms-3">
          <GoArrowDownRight size={45} />
        </span>
      </div>

      {/* formulario */}
      <form onSubmit={handleSubmit} className="px-4 pb-4 m_tl fs-5 m_font_primary m_f2f2f2">
        <div className="mx-2 my-3 w-100 m_input_contacto_form">
          <input
            type="text"
            placeholder="Nombre Completo*"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mx-2 my-3 w-100 m_input_contacto_form">
          <input
            placeholder="Correo electrónico*"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mx-2 my-3 w-100 m_input_contacto_form">
          <input
            placeholder="Número de teléfono"
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
          />
        </div>
        <div className="mx-2 my-3 w-100 m_input_contacto_form">
          <input
            placeholder="Empresa"
            type="text"
            name="empresa"
            value={formData.empresa}
            onChange={handleChange}
          />
        </div>
        <div className="mx-2 my-3 w-100 m_input_contacto_form">
          <input
            placeholder="Servicio de interés*"
            type="text"
            name="servicio"
            value={formData.servicio}
            onChange={handleChange}
          />
        </div>
        <div className="mx-2 my-3 w-100 m_input_contacto_form">
          <input
            placeholder="¿Cómo nos has encontrado?"
            type="text"
            name="fuente"
            value={formData.fuente}
            onChange={handleChange}
          />
        </div>
        <div className="mx-2 mb-3">
          <label className="m_text_secondary m_bl">Cuéntanos tu proyecto</label>
          <textarea
            name="proyecto"
            className="form-control"
            rows="4"
            value={formData.proyecto}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-check mb-3">
          <input
            type="checkbox"
            name="aceptaTerminos"
            className="form-check-input m_contacto_formInput"
            checked={formData.aceptaTerminos}
            onChange={handleChange}
          />
          <label className="m_text_orange m_bl">
            Acepto que WAZ utilice mis datos personales para responder a esta consulta.
          </label>
        </div>

        {error && <p className="text-danger">{error}</p>}

        <div className="m_dfc">
          <button
            type="submit"
            className="border-0 px-5 me-5 py-1 rounded-3 m_bg_amarillo"
            disabled={state.submitting}
          >
            Enviar
          </button>
        </div>

        {/* errores de Formspree */}
        <ValidationError prefix="Nombre" field="nombre" errors={state.errors} />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <ValidationError prefix="Mensaje" field="proyecto" errors={state.errors} />
      </form>
    </div>
  );
};
